import type { Translation } from '../types.ts';
import type en from '../en/imports.ts';

export default {
    title: 'Producten importeren',
    fixErrors: 'Verbeter de gemarkeerde velden.',
    upload: {
        title: 'CSV-bestand uploaden',
        intro: 'Exporteer uit WooCommerce, Shopify of een ander platform dat een CSV-bestand maakt. Variantregels worden platgeslagen: elke regel wordt één product, herkend aan de SKU.',
        reimport: 'Dezelfde SKU opnieuw importeren werkt het bestaande product bij.',
        categories: 'Ontbrekende categorieën worden automatisch aangemaakt (niet gepubliceerd).',
        images: "Afbeeldings-URL's worden naar je mediabibliotheek gedownload.",
        cleanup: 'Het CSV-bestand wordt verwijderd zodra de import klaar is.',
        choose: 'CSV-bestand kiezen…',
    },
    map: {
        title: 'Kolommen koppelen',
        intro: 'Koppel elk productveld aan een kolom in je CSV-bestand. We hebben op basis van gangbare exportformaten alvast een keuze gemaakt; pas die aan waar nodig. Verplichte velden zijn gemarkeerd met *.',
        productField: 'Productveld',
        csvColumn: 'CSV-kolom',
        sampleValue: 'Voorbeeldwaarde',
        skip: '(overslaan)',
        weightUnit: 'De gewichtskolom is in {unit}',
        grams: 'gram',
        kilograms: 'kilogram',
        dimensionUnit: 'Lengte, breedte en hoogte zijn in {unit}',
        millimetres: 'millimeter',
        centimetres: 'centimeter',
        preview: 'Eerste rij bekijken | Eerste {n} rijen bekijken',
        start: 'Import starten',
    },
    fields: {
        name: 'Naam',
        sku: 'SKU',
        priceCents: 'Prijs',
        brand: 'Merk',
        gtin: 'Barcode (EAN / GTIN)',
        shortDescription: 'Korte omschrijving',
        description: 'Omschrijving',
        stock: 'Voorraad',
        trackStock: 'Voorraad bijhouden',
        weightGrams: 'Gewicht',
        lengthMm: 'Lengte',
        widthMm: 'Breedte',
        heightMm: 'Hoogte',
        shippingSizeClass: 'Pakketformaat',
        categories: 'Categorieën',
        tags: 'Tags',
        images: 'Afbeeldingen',
        published: 'Gepubliceerd',
        featured: 'Uitgelicht',
    },
    progress: {
        title: 'Importeren…',
        rows: '{processed} van {total} rijen ({ok} gelukt, {failed} mislukt)',
    },
    done: {
        complete: 'Import voltooid',
        finished: 'Import afgerond',
        finishedWithErrors: 'Import afgerond, met fouten',
        imported: 'Geïmporteerd',
        failed: 'Mislukt',
        rowsFailed: '{n} rij kon niet worden geïmporteerd. | {n} rijen konden niet worden geïmporteerd.',
        rowError: 'Rij {row}: {message}',
        downloadErrors: 'Volledige foutenlijst downloaden (CSV)',
        another: 'Nog een bestand importeren',
        backToProducts: 'Terug naar producten',
    },
    status: {
        queued: 'In de wachtrij',
        running: 'Bezig',
        complete: 'Voltooid',
        failed: 'Mislukt',
    },
} satisfies Translation<typeof en>;
